import { IonAlert, useIonAlert } from '@ionic/react';
import { AlertButton, AlertOptions } from '@ionic/core';
import React, { forwardRef, useCallback } from 'react';
import './Modal.css';

/** Usa o cancelamento nativo do Ionic, sem executar ações de confirmação ao clicar no X. */
export function modalAlertOptions<T extends AlertOptions>(options: T): T & AlertOptions {
  const buttons = options.buttons || [];
  const cancel = buttons.find((button): button is AlertButton => typeof button !== 'string' && button.role === 'cancel');
  // Um diálogo obrigatório sem cancelamento continua obrigatório (pagamento, PIN, etc.).
  const canClose = !!cancel || options.backdropDismiss !== false;
  const cssClass = [...(Array.isArray(options.cssClass) ? options.cssClass : [options.cssClass || '']), 'xeguei-alert', canClose ? 'xeguei-alert-dismissible' : ''].filter(Boolean);
  return {
    ...options,
    cssClass,
    buttons: canClose ? [...buttons, { text: 'Fechar', role: 'cancel', cssClass: 'xeguei-alert-close', handler: cancel?.handler }] : buttons,
  };
}

export function useModalAlert(): ReturnType<typeof useIonAlert> {
  const [present, dismiss] = useIonAlert();
  const show = useCallback((options: any, buttons?: AlertButton[]) => present(modalAlertOptions(typeof options === 'string' ? { message: options, buttons } : options)), [present]);
  return [show, dismiss];
}

const ModalAlert = forwardRef<HTMLIonAlertElement, React.ComponentProps<typeof IonAlert>>((props, ref) => <IonAlert {...modalAlertOptions(props)} ref={ref} />);
export default ModalAlert;
